<template>
  <div>
    <v-card>
      <div class="pa-4">
        <h4>Recent</h4>
      </div>
      <v-divider></v-divider>
      <notification
        v-for="notification of lc_getRecentNotification()"
        :key="notification.id"
        :item="notification"
      />
    </v-card>
    <v-card class="mt-8">
      <div class="pa-4">
        <h4>Earlier</h4>
      </div>
      <v-divider></v-divider>
     <notification
        v-for="notification of lc_getEarlierNotification()"
        :key="notification.id"
        :item="notification"
      />
    </v-card>
  </div>
</template>

<script>
import Notification from "../components/Notification/Notification.vue";
import moment from "moment";
export default {
  components: { Notification },
  name: "notifications",
  methods: {
    lc_getRecentNotification() {
      let notificationsTemp = this.notifications;
      return notificationsTemp.filter(
        (notification) =>
          moment(notification.datetime.toDate()).format("DD-MM-YYYY") ==
          moment(new Date()).format("DD-MM-YYYY")
      );
    },
    lc_getEarlierNotification() {
      let notificationsTemp = this.notifications;
      return notificationsTemp.filter(
        (notification) =>
          moment(notification.datetime.toDate()).format("DD-MM-YYYY") <
          moment(new Date()).format("DD-MM-YYYY")
      );
    },
  },
};
</script>

<style scoped>
.border {
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 10px;
  border-radius: 6px;
}
</style>
